export default __webpack_public_path__ + "static/media/landing.9ae78cd9.png";